import { InjectionToken } from '@angular/core';
import { guid } from '@valhalla/utils';

const id = guid();

export const BROWSER_TAB_ID = new InjectionToken<string>('browserTabId', {
	providedIn: 'root',
	factory: () => id,
});
